import React from 'react'
import container from './container'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Form, Spin, Card, Input, Button, Select, Row, Col, Space } from 'antd'
import { REGION_SOURCES } from '../CoverageCommon'

const RegionCoverageSearch = props => {
    const { $props, $loading, $fieldProps, canCreate, onCreate } = props
    return (
        <Spin spinning={$loading}>
            <Form colon={false} {...$props} initialValues={{ supplier_code: '' }}>
                <Card
                    title="Region Coverage"
                    size="small"
                    extra={
                        <Space>
                            {canCreate ? (
                                <Button onClick={() => onCreate()}>
                                    <PlusOutlined /> New region mapping
                                </Button>
                            ) : null}
                            <Button htmlType={'submit'} type="primary">
                                <SearchOutlined /> Find
                            </Button>
                        </Space>
                    }>
                    <div className="d-md-flex align-items-center">
                        <Card.Meta description="Hotels that hotel_mapping_v2 links to one region, and how well each supplier catalog covers them. Search reads every source of a region, so 'All sources' is what search sees." />
                    </div>
                    <br />
                    <Row gutter={16}>
                        <Col xs={24} md={4}>
                            <Form.Item name={'supplier_code'} wrapperCol={{ flex: 1 }}>
                                <Select style={{ width: '100%' }}>
                                    <Select.Option value={''}>All sources</Select.Option>
                                    {REGION_SOURCES.map(source => (
                                        <Select.Option value={source} key={source}>
                                            {source}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={20}>
                            <Form.Item name={'region_id'} wrapperCol={{ flex: 1 }} {...$fieldProps.region_id}>
                                <Input placeholder="Enter a region_id (3023)" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>
            </Form>
        </Spin>
    )
}

export default container(RegionCoverageSearch)
